import { Colors } from "./Colors";

export const Styles = {
    PRIMARY_COLOR: Colors.MAIN,
    PRIMARY_COLOR_ACTIVE: Colors.MAIN,
};
